import axios from 'axios'
import pageKeys from '../common/pagekeys'

export default {
    async getAll() {
        try{            
            const response = await axios.get(`Banks`, {
                headers: {
                    'page_key': pageKeys.employees
                }
            })                     
            return response
        }catch (error){
            console.log('Banks api getAll error')
            throw error
        }
    },
    async add(data) {
        try {       
            const response = await axios.post(`Banks/account`, 
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.employees
                }
            })                     
            return response
        }catch (error){
            console.log('Banks api add error')
            throw error
        }
    },
    async update(data) {
        try {            
            const response = await axios.patch(`Banks/account`, 
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.employees
                }
            })                     
            return response
        }catch (error){
            console.log('Banks api update error')
            throw error
        }
    }
}